import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { CouponService } from 'src/app/services/http/business/coupon/coupon.service';
import { PaymentService } from 'src/app/services/http/business/payment/payment.service';

@Component({
  selector: 'app-account-detail',
  templateUrl: './account-detail.component.html',
  styleUrls: ['./account-detail.component.css']
})
export class AccountDetailComponent implements OnInit {
  couponList = [];
  wallet: any;
  constructor(
    public translate: TranslateService,
    public dialogRef: MatDialogRef<AccountDetailComponent>,
    private couponService: CouponService,
    private paymentService: PaymentService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {

    this.getUserCouponsStudent();
    this.getWallet();

  }

  getUserCouponsStudent() {

    this.couponService.listAllUser(this.data.NationalCode).subscribe(res => {
      this.couponList = res.DataList;
    }, () => {

    })
  }

  getWallet() {
    this.paymentService.getWallet(this.data.NationalCode).subscribe(
      res => {
        this.wallet = res.CreditCompany;
      }
    );
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

}
